var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdminForm',{attrs:{"config":_vm.config,"form":_vm.form,"isBusy":_vm.isBusy,"options":_vm.options}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3683651a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StorageEnvironment/StorageEnvironmentForm.vue
// module id = 770
// module chunks = 0